
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "contact",
      resolverType: "mutation",
      routePath: "/contact",
      httpMethod: "POST",
    });
  